import PoolCustomWorkoutView from 'components/views/PoolView/PoolCustomWorkoutView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { actionCreators as assetsAC } from 'store/assets';
import { actionCreators as eventsAC } from 'store/events';
import { getExerciseImage } from 'store/exercises';
import { actionCreators as layoutAC } from 'store/layout';
import { getIsAuthenticated } from 'store/login';
import { ProfileDataType } from 'store/profile';
import { getHasUserBeenLoaded, getUserData, getWeight } from 'store/profile';
import { getCurrentDayNumber } from 'store/programDays';
import { IRootState } from 'store/rootReducer';
import { actionCreators as transientPoolAC, getActiveOverlayRef, getProgramItemRef } from 'store/transientPoolState';
import { WithRouterType } from 'types/withRouter';

export type PoolCustomWorkoutViewContainerProps = WithRouterType & {
	id: string;
	programItemRef?: string;
	activeOverlayRef?: string;
	isAuthenticated: boolean;
	weight?: number;
	currentDayNumber: number;
	userData: ProfileDataType;
};

export const mapStateToProps = (state: IRootState, props: PoolCustomWorkoutViewContainerProps) => {
	const staticCustomWorkoutID = getProgramItemRef(state) || 'custom-workout-static-id';

	return {
		...props,
		id: staticCustomWorkoutID,
		currentDayNumber: getCurrentDayNumber(state),
		isAuthenticated: getIsAuthenticated(state),
		isUserLoaded: getHasUserBeenLoaded(state),
		userData: getUserData(state),
		programItemRef: getProgramItemRef(state),
		activeOverlayRef: getActiveOverlayRef(state),
		previewImage: getExerciseImage(state, staticCustomWorkoutID),
		weight: getWeight(state),
	};
};

export const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(
		{
			doLockBody: layoutAC.doLockBody,
			doUnsetProgramItemRef: transientPoolAC.doUnsetProgramItemRef,
			doAddEvents: eventsAC.doAddEvents,
			doLoadAsset: assetsAC.doLoadAsset,
		},
		dispatch
	);
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default withRouter((connector as any)(PoolCustomWorkoutView));
